export const openPdfBlob = (blob: any, fileName: string) => {
    if (blob !== null && typeof window !== 'undefined') {

        const doc = new Blob([blob], { type: "application/pdf" })
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(doc);
            return;
        }


        const docURL = URL.createObjectURL(doc)

        var link = document.createElement('a');
        link.href = docURL;
        link.download = fileName;
        link.click();

        setTimeout(function() {
            // For Firefox it is necessary to delay revoking the ObjectURL
            if (typeof window !== 'undefined' && window.URL) {
                window.URL.revokeObjectURL(docURL);
            }
        }, 100);

    }
}
